import { render } from "./OnlinePayAssesment.vue?vue&type=template&id=eb78dd94&scoped=true"
import script from "./OnlinePayAssesment.vue?vue&type=script&lang=js"
export * from "./OnlinePayAssesment.vue?vue&type=script&lang=js"

import "./OnlinePayAssesment.vue?vue&type=style&index=0&id=eb78dd94&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb78dd94"]])

export default __exports__